<template>
	<div class="bg-brand-taupe-500 pb-10">
		<form @submit.prevent="store" autocomplete="off">
			<PageHeader :headingContent="headingContent" />
			<div class="container mx-auto mt-10 mb-4">
				<div class="flex px-4 gap-4 justify-between ">
					<div class="">
						<h1 class="text-2xl text-brand-blue-400 font-display uppercase">Review</h1>
					</div>
					<div class="">
						<button class="
							bg-brand-green-400
							hover:bg-brand-green-200
							text-white
							font-bold
							py-2
							px-4
							rounded
							justify-right
							uppercase
						" type="submit">
							Save
						</button>
					</div>
				</div>
				<div class="container mx-auto mb-4">

					<div class="px-4">
						<input type="hidden" id="id" v-model="form.id">
						<input type="hidden" id="user_id" v-model="form.user_id">
						<label for="title" class="block text-gray-700 text-sm font-bold mb-2" >Title</label>
						<input id="title" v-model="form.title"
							class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mb-4" autocomplete="off"/>
						<label for="body" class="block text-gray-700 text-sm font-bold mb-2">Description</label>
						<textarea id="body" v-model="form.body"
							class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mb-4">
					{{ form.body }}
					</textarea>
						<input type="hidden" id="review_id" v-model="form.review_id" />
						<input type="hidden" id="review_id" v-model="form.review_id" />
					</div>
					<!-- <template v-for="section in this.reviewTemplate.sections">
					<Section :section="section" :review="review" />
				</template> -->
				</div>
			</div>
		</form>
	</div>
</template>

	<script>
	import PageHeader from "../../Shared/PageHeader";
	import Section from "./Components/Section"
	
	export default {
		props: ['review', 'reviewTemplate'],
		components: {
			PageHeader,
			Section,
		},
		data: function () {
			return {
				form: this.$inertia.form({
					id: '',
					user_id: '',
					title: '2ca998d6-e09a-42fb-9cf6-f994628d11c9',
					body: '216cc0af-790f-4da5-a75f-0b52a36c1c43',
					question_id: '9e9835b0-ed7b-4a8b-896a-da1776531ac8',
					answer_id: 'bbab3060-4992-4d05-8e29-e6b0f3ada2d7',
				}),
				headingContent: {
					hero: {
						image: '/images/254411986_car_hero.jpg',
						title: 'Fleet Risk Review',
						subtitle: 'In association with AXA Insurance',
					},
					page: {
						title: '',
						subtitle: '',
					},
				}
			}
		},
		methods: {
			store() {
				// console.log('store')
				this.form.post('/reviews')
			},
		},
		mounted() {
			this.form.id = this.review.id;
			this.form.user_id = this.review.user_id;
			this.form.title = this.review.title;
			this.form.body = this.review.body;
		}
	}
	</script>
